import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { invitationActionsSaga } from "./sagas/invitationActionsSaga";
import { openInvitationModalSaga } from "./sagas/openInvitationModalSaga";
import { invitationDataProvider } from "./provider/invitationDataProvider";
import { InvitationModal } from "./components/InvitationModal";
import { InvitationConfirmModal } from "./components/invitationConfirmModal";
import { cleanIsDirtyOnCancelMiddleware } from "./middlewares/cleanIsDirtyOnCancelMiddleware";

const invitationModule = (): Module => ({
	id: "invitationModule",
	views: () => viewComponentProvider,
	sagas: () => [openInvitationModalSaga, invitationActionsSaga],
	dataProviders: () => [invitationDataProvider],
	middlewares: () => [cleanIsDirtyOnCancelMiddleware]
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	InvitationModal,
	InvitationConfirmModal
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default invitationModule;
